import {inject, Pipe, PipeTransform} from '@angular/core';
import {DomSanitizer, SafeHtml} from '@angular/platform-browser';
import DOMPurify from 'dompurify';

@Pipe({name: 'safeHtml'})
export class SafeHtmlPipe implements PipeTransform {
  private readonly sanitizer = inject(DomSanitizer);

  transform(html: string | null | undefined): SafeHtml {
    const sanitizedContent = DOMPurify.sanitize(html ?? '', {ADD_ATTR: ['target']});
    return this.sanitizer.bypassSecurityTrustHtml(sanitizedContent);
  }
}
